<div class="page-header clearfix">
  <a
    class="page-header__back"
    uiSref="project-performance"
    [uiParams]="{
      page: 1,
      queryPage: 1,
      sortColumn: undefined,
      sortDesc: undefined,
      search: undefined
    }"
    >&lsaquo; Performance</a
  >
  <h1 class="page-header__title text-truncate">
    <ab-env-label [env]="route.environment" [truncate]="false"></ab-env-label>
    <ab-route-method [method]="routeStats?.method"></ab-route-method>
    <ab-route-name
      class="page-header__element"
      [routeName]="route.route"
    ></ab-route-name>
  </h1>
  <ab-time-dur-switch
    class="page-header__element"
    [enabled]="timeDurSwitchEnabled"
    [dur]="dur"
    [lastN]="lastN"
    (changed)="onTimeDurSwitchChange($event)"
  ></ab-time-dur-switch>
  <ab-response-code-switch
    class="page-header__element"
    [routeStats]="[routeStats]"
    [statusCode]="statusCode"
  ></ab-response-code-switch>
</div>
<div class="container-fluid bkg-color--white">
  <div class="row pt-3">
    <ab-performance-breakdown
      class="col-6"
      [route]="route"
      [dur]="dur"
      [lastN]="lastN"
    ></ab-performance-breakdown>
    <ab-route-cards
      class="col-6"
      [routesStats]="routeStats"
      [errorRateList]="errorRateList"
      [statusCode]="statusCode"
      [loading]="loadingRouteStats"
      [project]="project"
      [dur]="dur"
      [lastN]="lastN"
      [showPerformanceBreakdown]="true"
    ></ab-route-cards>
  </div>
  <ab-route-charts
    class="row row-padding-top"
    [routesStats]="routeStats"
    [statusCode]="statusCode"
    [loading]="loadingRouteStats"
    [project]="project"
    [dur]="dur"
    [lastN]="lastN"
  ></ab-route-charts>
  <ab-error-cards
    class="row pt-3"
    [project]="project"
    [routeStats]="routeStats"
    [timeDurAgo]="timeDurAgo"
    [dur]="dur"
  ></ab-error-cards>
  <div class="row pt-3">
    <div class="col-lg-12">
      <ab-query-table
        [route]="route"
        [timeDurAgo]="timeDurAgo"
        [dur]="dur"
        [project]="project"
      ></ab-query-table>
    </div>
  </div>
</div>
